// SwitchButton.tsx
import styled from "styled-components";
import { motion } from "framer-motion";

const Wrapper = styled.div`
  width: 160px;
  height: 40px;
  background: #e5e7eb;
  border-radius: 25px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  cursor: pointer;
`;

const Label = styled.div<{ $active: boolean }>`
  flex: 1;
  text-align: center;
  z-index: 1;
  color: ${({ $active }) => ($active ? "#fff" : "#a9a9a9")};
  font-weight: 500;
  font-size: 1.4rem;
`;

const Slider = styled(motion.div)`
  width: 50%;
  height: 100%;
  background: #30a690;
  border-radius: 25px;
  position: absolute;
  top: 0;
  left: 0;
`;

interface SwitchButtonProps {
  value: "user" | "admin";
  onChange: (value: "user" | "admin") => void;
}

const SwitchButton = ({ value, onChange }: SwitchButtonProps) => {
  const handleToggle = () => {
    const newValue = value === "user" ? "admin" : "user";
    onChange(newValue);
  };

  return (
    <Wrapper onClick={handleToggle}>
      <Slider
        layout
        transition={{ type: "spring", stiffness: 300, damping: 30 }}
        style={{ left: value === "user" ? 0 : "50%" }}
      />
      <Label $active={value === "user"}>사용자</Label>
      <Label $active={value === "admin"}>관리자</Label>
    </Wrapper>
  );
};

export default SwitchButton;
